 
var Component = videojs.getComponent('Component');
var CustomLogo = videojs.extend(Component, {
  constructor: function () {
    Component.apply(this, arguments);
    /* initialize your button */
  },
  // handleClick: function () {
  //   /* do something on click */
  // },
  createEl: function () {

    var link = {};

    if (this.options() && this.options().href) {

      var properties = {
        className: 'vjs-customlogo-link vjs-customlogo',
        href: this.options().href,
        target: "_blank"
      };

      if(this.options().title){
        properties.title =  this.options().title;
      }
     return  videojs.createEl('a', properties, {}, {});
    }

    // return videojs.createEl('div', {

    //   // Prefixing classes of elements within a player with "vjs-" 
    //   // is a convention used in Video.js.
    //   className: 'vjs-customlogo',

    // }, {}, link);
  }

});
videojs.registerComponent('CustomLogo', CustomLogo);


//////////////////
// WEBPACK FOOTER
// ./js/logo.js
// module id = 22
// module chunks = 0